module.exports = __webpack_public_path__ + "static/media/sold_out.ff49c1cc.png";